import React from 'react';

export default function ShapeElement({ 
  shape, 
  position, 
  size, 
  style, 
  scale = 1,
  messengerStyle = false
}) {
  const borderRadiusValue = shape === 'circle' 
    ? '50%' 
    : messengerStyle 
      ? '12px' 
      : (style?.borderRadius || '0');

  // Render triangle with CSS borders (match design component behavior)
  if (shape === 'triangle') {
    const w = size.width * scale;
    const h = size.height * scale;
    return (
      <div
        style={{
          position: 'absolute',
          left: `${position.x * scale}px`,
          top: `${position.y * scale}px`,
          width: `${w}px`,
          height: `${h}px`,
          opacity: style?.opacity ?? 1,
        }}
      >
        <div
          style={{
            width: 0,
            height: 0,
            borderLeft: `${w / 2}px solid transparent`,
            borderRight: `${w / 2}px solid transparent`,
            borderBottom: `${h}px solid ${style?.fill || '#000000'}`,
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />
      </div>
    );
  }

  // Default rectangle/circle
  return (
    <div 
      style={{
        position: 'absolute',
        left: `${position.x * scale}px`,
        top: `${position.y * scale}px`,
        width: `${size.width * scale}px`,
        height: `${size.height * scale}px`,
        backgroundColor: style?.fill || '#000000',
        opacity: style?.opacity || 1,
        borderRadius: borderRadiusValue,
        boxShadow: messengerStyle ? '0 1px 2px rgba(0, 0, 0, 0.1)' : 'none',
        margin: messengerStyle ? '4px 0' : '0',
      }} 
    />
  );
}